import React from 'react'

const Preloader = () => {
    return (
        <div className="preloader flex-column justify-content-center align-items-center">
            <img className="animation__shake" src="../../dist/img/AdminLTELogo.png" alt="CaronaApp" height="60" width="60" />
        </div>
    )
}

export default Preloader
